/**
 * Yarn Gift Certificates Section Interactive Logic
 * Upload to: assets/yarn-gift-certificates.js
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.ygcInit === 'true') return;
    root.dataset.ygcInit = 'true';

    // Intersection Observer for Smooth Reveal Animation
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-inview');
              root.classList.remove('is-offscreen');
            } else {
              root.classList.add('is-offscreen');
            }
          });
        },
        { threshold: 0.12 }
      );
      observer.observe(root);
    } else {
      root.classList.add('is-inview');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-yarn-gift-certificates]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Customizer Support
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-yarn-gift-certificates]') ||
      (event.target.matches('[data-yarn-gift-certificates]') ? event.target : null);
    if (root) {
      root.removeAttribute('data-ygc-init');
      initSection(root);
    }
  });
})();
